import { type PropsWithChildren } from "react";

export const Header = ({ children }: Readonly<PropsWithChildren>) => (
  <header data-testid="circle-ai-shell-panel-header" className="shrink-0">
    {children}
  </header>
);

Header.displayName = "CircleAIAppShell.Layout.Panel.Header";
